import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
}

export const Wordmark: FC<WordmarkProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('block pl-[0.34em] font-heading font-medium uppercase leading-none tracking-[0.34em]', className)}>
            Vaurel
        </span>
    )
}
